module.exports = __webpack_public_path__ + "static/media/icon-wallet-inactive@2x.866b33be.png";